import { dateOf, daysBetween, type Instant } from './time';
import { percentOf, sum, type Rupees } from './money';
import { calc, span } from './pricing';
import type { BookingRecord } from './types';

export interface CancelSuggestion {
  daysBefore: number;
  paid: Rupees;
  advance: Rupees;
  refund: Rupees;
  retained: Rupees;
  rule: 'none' | 'full' | 'forfeit';
}

/**
 * Policy from the record's own quote terms (not current settings):
 *  - cancelled ≥ fullRefundDays calendar days before the start date (IST) → refund everything paid;
 *  - otherwise forfeitPct of the advance paid is retained (rounded half-up to whole rupees, never more than paid).
 * "Advance paid" = all non-voided payments of type advance. The owner can override the refund.
 */
export function cancelSuggest(r: BookingRecord, now: Instant): CancelSuggestion {
  const c = r.terms.cancel, k = calc(r);
  const daysBefore = daysBetween(dateOf(now), dateOf(span(r).start));
  const advance = sum(r.payments.filter(p => !p.voided && p.type === 'advance').map(p => p.amount));
  const paid = Math.max(0, k.paid);
  if (!c.enabled) return { daysBefore, paid, advance, refund: paid, retained: 0, rule: 'none' };
  if (daysBefore >= c.fullRefundDays) return { daysBefore, paid, advance, refund: paid, retained: 0, rule: 'full' };
  const retained = Math.min(paid, percentOf(advance, c.forfeitPct));
  return { daysBefore, paid, advance, refund: paid - retained, retained, rule: 'forfeit' };
}
